import { render, staticRenderFns } from "./DashboardReportItem.vue?vue&type=template&id=c5afaa80&scoped=true"
import script from "./DashboardReportItem.vue?vue&type=script&lang=ts"
export * from "./DashboardReportItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5afaa80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5afaa80')) {
      api.createRecord('c5afaa80', component.options)
    } else {
      api.reload('c5afaa80', component.options)
    }
    module.hot.accept("./DashboardReportItem.vue?vue&type=template&id=c5afaa80&scoped=true", function () {
      api.rerender('c5afaa80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/DashboardReportItem.vue"
export default component.exports